export const lang = {
    en:{
        search: "Search",
        gptSearchPlaseholder:"What Would you like to watch?",
    },
    hindi:{
        search: "खोज",
        gptSearchPlaseholder:"आप क्या देखना चाहेंगे",
    },
    spanish:{
        search: "buscar",
        gptSearchPlaseholder:"Qué te gustaría ver?",
    },
    kannada:{
        search: "ಹುಡುಕಿ",
        gptSearchPlaseholder:"ನೀವು ಏನನ್ನು ವೀಕ್ಷಿಸಲು ಬಯಸುತ್ತೀರಿ?",
    }
}